import { setGlobalState, useGlobalState } from '../store'
const Hero = () => {
  const [stats] = useGlobalState('stats')

  return (
    <div className="text-center bg-white text-gray-800 py-24 px-6">
      <div className='grid grid-cols-2 gap-0'>
        <div className='flex justify-left items-left place-items-left'>
          <img src='2295485.jpg' width={'600px'}/>
        </div>
        <div>
          <h1 className="text-5xl md:text-6xl xl:text-7xl font-bold tracking-tight -ml-20 mt-20">
            <span className="capitalize text-sky-300">Empowering Dreams,</span>
            <br />
            <span className="font-medium text-orange-400">One Campaign at a Time.</span>
          </h1>
          <p className="font-medium text-grey-400 mt-20 text-lg">Welcome to <span className='font-bold text-rose-300'>GiveHope</span> - the platform where you can turn your dreams into reality! Create a campaign today and reach out to the global community for support. Let's get started on your journey towards success!.</p>
        </div>
      </div>
      <div className="flex justify-center items-center space-x-2">
        <button
          type="button"
          className="flex px-8 py-3.5 bg-sky-400 text-white font-medium text-sm leading-tight uppercase rounded-full shadow-md hover:bg-blue-700"
          onClick={() => setGlobalState('createModal', 'scale-100')}
        >
          Add Project
          <img className='ml-2 -mt-[2px] rounded-lg' src='logo.jpg' width="20px"/>

        </button>

        <button
          type="button"
          className="flex px-8 py-3.5 border border-sky-400 font-medium text-sm leading-tight uppercase text-sky-500 rounded-full shadow-md bg-transparent hover:bg-blue-700 hover:text-white"
        >
          Back Projects
        </button>
      </div>

      <div className="flex justify-center items-center mt-10">
        <div
          className="flex flex-col justify-center items-center
          h-20 border shadow-md w-full"
        >
          <span
            className="text-lg font-bold text-blue-900
            leading-5"
          >
            {stats?.totalProjects || 0}
          </span>
          <span>Projects</span>
        </div>
        <div
          className="flex flex-col justify-center items-center
          h-20 border shadow-md w-full"
        >
          <span
            className="text-lg font-bold text-blue-900
            leading-5"
          >
            {stats?.totalBacking || 0}
          </span>
          <span>Backings</span>
        </div>
        <div
          className="flex flex-col justify-center items-center
          h-20 border shadow-md w-full"
        >
          <span
            className="text-lg font-bold text-blue-900
            leading-5"
          >
            {stats?.totalDonations || 0} ETH
          </span>
          <span>Donated</span>
        </div>
      </div>
    </div>
  )
}

export default Hero
